import { render, staticRenderFns } from "./ProviderPickerChannels.vue?vue&type=template&id=49b9bf7e&scoped=true&"
import script from "./ProviderPickerChannels.vue?vue&type=script&lang=js&"
export * from "./ProviderPickerChannels.vue?vue&type=script&lang=js&"
import style0 from "./ProviderPickerChannels.vue?vue&type=style&index=0&id=49b9bf7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b9bf7e",
  null
  
)

export default component.exports